import { FormType } from '../../../form-types';
import { FacialAntiAgingQuestionFieldAnswers } from './questions';

export const facialAntiAging: FormType<FacialAntiAgingQuestionFieldAnswers> = {
  name: 'Facial Anti Aging',
  questions: [
    {
      key: 'facialAntiAging_sexAssignedAtBirth',
      next: {
        condition: { 'facialAntiAging_sexAssignedAtBirth.female': true },
        key: 'facialAntiAging_pregnancy',
        els: 'facialAntiAging_focusAreas'
      }
    },
    {
      key: 'facialAntiAging_pregnancy',
      next: {
        condition: { 'facialAntiAging_pregnancy.yes': true },
        key: 'facialAntiAging_ineligible',
        els: 'facialAntiAging_pregnancyConsent'
      }
    },
    {
      key: 'facialAntiAging_pregnancyConsent',
      next: {
        condition: { 'facialAntiAging_pregnancyConsent.non_consent': true },
        key: 'facialAntiAging_ineligible',
        els: 'facialAntiAging_focusAreas'
      }
    },
    'facialAntiAging_focusAreas',
    {
      key: 'facialAntiAging_goals',
      next: {
        switch: [
          {
            condition: { 'facialAntiAging_goals.goal_wrinkles': true },
            key: 'facialAntiAging_wrinklesLocations'
          },
          {
            condition: { 'facialAntiAging_goals.goal_dark_spots': true },
            key: 'facialAntiAging_darkSpots'
          },
          {
            condition: { 'facialAntiAging_goals.goal_blemish': true },
            key: 'facialAntiAging_blemishSeverity'
          },
          {
            condition: { 'facialAntiAging_goals.goal_redness': true },
            key: 'facialAntiAging_rednessConcerns'
          },
          {
            condition: { 'facialAntiAging_goals.goal_firmness': true },
            key: 'facialAntiAging_firmnessGoals'
          },
          {
            condition: { 'facialAntiAging_goals.goal_undereye': true },
            key: 'facialAntiAging_undereyeConcerns'
          }
        ],
        els: 'facialAntiAging_skinType'
      }
    },
    {
      key: 'facialAntiAging_wrinklesLocations',
      next: {
        switch: [
          {
            condition: { 'facialAntiAging_goals.goal_dark_spots': true },
            key: 'facialAntiAging_darkSpots'
          },
          {
            condition: { 'facialAntiAging_goals.goal_blemish': true },
            key: 'facialAntiAging_blemishSeverity'
          },
          {
            condition: { 'facialAntiAging_goals.goal_redness': true },
            key: 'facialAntiAging_rednessConcerns'
          },
          {
            condition: { 'facialAntiAging_goals.goal_firmness': true },
            key: 'facialAntiAging_firmnessGoals'
          },
          {
            condition: { 'facialAntiAging_goals.goal_undereye': true },
            key: 'facialAntiAging_undereyeConcerns'
          }
        ],
        els: 'facialAntiAging_skinType'
      }
    },
    {
      key: 'facialAntiAging_darkSpots',
      next: {
        switch: [
          {
            condition: { 'facialAntiAging_goals.goal_blemish': true },
            key: 'facialAntiAging_blemishSeverity'
          },
          {
            condition: { 'facialAntiAging_goals.goal_redness': true },
            key: 'facialAntiAging_rednessConcerns'
          },
          {
            condition: { 'facialAntiAging_goals.goal_firmness': true },
            key: 'facialAntiAging_firmnessGoals'
          },
          {
            condition: { 'facialAntiAging_goals.goal_undereye': true },
            key: 'facialAntiAging_undereyeConcerns'
          }
        ],
        els: 'facialAntiAging_skinType'
      }
    },
    {
      key: 'facialAntiAging_blemishSeverity',
      next: {
        switch: [
          {
            condition: { 'facialAntiAging_goals.goal_redness': true },
            key: 'facialAntiAging_rednessConcerns'
          },
          {
            condition: { 'facialAntiAging_goals.goal_firmness': true },
            key: 'facialAntiAging_firmnessGoals'
          },
          {
            condition: { 'facialAntiAging_goals.goal_undereye': true },
            key: 'facialAntiAging_undereyeConcerns'
          }
        ],
        els: 'facialAntiAging_skinType'
      }
    },
    {
      key: 'facialAntiAging_rednessConcerns',
      next: {
        switch: [
          {
            condition: { 'facialAntiAging_goals.goal_firmness': true },
            key: 'facialAntiAging_firmnessGoals'
          },
          {
            condition: { 'facialAntiAging_goals.goal_undereye': true },
            key: 'facialAntiAging_undereyeConcerns'
          }
        ],
        els: 'facialAntiAging_skinType'
      }
    },
    {
      key: 'facialAntiAging_firmnessGoals',
      next: {
        switch: [
          {
            condition: { 'facialAntiAging_goals.goal_undereye': true },
            key: 'facialAntiAging_undereyeConcerns'
          }
        ],
        els: 'facialAntiAging_skinType'
      }
    },
    {
      key: 'facialAntiAging_undereyeConcerns',
      next: { key: 'facialAntiAging_skinType' }
    },
    'facialAntiAging_skinType',
    {
      key: 'facialAntiAging_acuteConcerns',
      next: {
        switch: [
          {
            condition: {
              'facialAntiAging_acuteConcerns.changing_lesion': true
            },
            key: 'facialAntiAging_ineligible'
          },
          {
            condition: { 'facialAntiAging_acuteConcerns.vision_eye': true },
            key: 'facialAntiAging_ineligible'
          },
          {
            condition: {
              'facialAntiAging_acuteConcerns.active_infection': true
            },
            key: 'facialAntiAging_ineligible'
          },
          {
            condition: {
              'facialAntiAging_acuteConcerns.photosensitizing': true
            },
            key: 'facialAntiAging_ineligible'
          }
        ],
        els: 'facialAntiAging_productReactions'
      }
    },
    'facialAntiAging_productReactions',
    {
      key: 'facialAntiAging_programEducationConsent',
      next: {
        condition: {
          'facialAntiAging_programEducationConsent.non_consent': true
        },
        key: 'facialAntiAging_ineligible',
        els: 'facialAntiAging_otherInformation'
      }
    },
    'facialAntiAging_otherInformation',
    {
      key: 'facialAntiAging_truthConsent',
      next: {
        condition: { 'facialAntiAging_truthConsent.non_consent': true },
        key: 'facialAntiAging_ineligible',
        els: 'facialAntiAging_medicationConsent'
      }
    },
    {
      key: 'facialAntiAging_medicationConsent',
      next: {
        condition: {
          'facialAntiAging_medicationConsent.non_consent': true
        },
        key: 'facialAntiAging_ineligible',
        els: 'facialAntiAging_complete'
      }
    },
    'facialAntiAging_complete',
    'facialAntiAging_ineligible'
  ]
};
